/* eslint-disable */
import React from "react";

const HTML = React.forwardRef(({ children, ...props }, ref) => (
  <div ref={ref} dangerouslySetInnerHTML={{ __html: children }} {...props} />
));

export default HTML;
